import { useContext } from 'react';
import {
  StationObservationsCtx,
  type StationObservationsContextValue,
} from './stationObservationsCtx';

export function useStationObservations(): StationObservationsContextValue {
  const ctx = useContext(StationObservationsCtx);
  if (!ctx) {
    throw new Error(
      'useStationObservations must be used within StationObservationsProvider',
    );
  }
  return ctx;
}

export function useStationObservationsOptional(): StationObservationsContextValue | null {
  return useContext(StationObservationsCtx);
}
